import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'
import moment from 'moment'

const DEEP = { deep: true }
const d = { deep: true }

export const CompaniesRedux = createActions({
  contactsCreateRequest: ['id', 'data'],
  contractCreateRequest: ['id', 'data'],
  contractCreateSuccess: ['data'],
  contractCreateError: ['error'],
  contractUpdateSuccess: ['data'],
  contractRestoreSuccess: ['id'],
  contractRemoveSuccess: ['data'],
  contractCreateReset: null,
  getPaymentTypesRequest: [''],
  getPaymentTypesSuccess: ['result'],
  getPaymentTypesError: ['error'],
  updateInvoiceDetailsRequest: ['id', 'data'],
  updateInvoiceDetailsSuccess: ['results'],
  // setAvailableProducts:['data'],
  // setAvailableCenters:['data'],
  // setParamters:[''],
}, {
  prefix: 'COMPANIES_',
  defaultActions: {
    get: true,
    getOne: true,
    create: true,
    update: true,
    remove: true,
    restore: true,
    reset: true,
  },
})

const { Types, Creators } = CompaniesRedux
export const CompaniesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  getAvailableCenters: {
    fetching: false,
  },
  newContract: {
    saving: false,
    success: false,
    error: '',
  },
  paymentsTypes: {
    result: [],
    fetching: false,
    error: '',
  },
}, {
  get: true,
  getOne: true,
  create: true,
  update: true,
  remove: true,
  restore: true,
  reset: true,
})

/* ------------- Reducers ------------- */

// const setParamters = (state,) => (
//   state.merge(
//     {},
//     DEEP,
//   )
// )
// const setAvailableProducts = (state,{data}) => (
//   state.merge(
//     {
//       getOne: { result: { available_products: data } },
//     },
//     DEEP,
//   )
// )
// const setAvailableCenters = (state,{data}) =>(
//   state.merge(
//     {
//       getOne: { result: { available_centers: data } },
//     },
//     DEEP,
//   )
// )
const contractCreateRequest = state =>
  state.merge({ newContract: { saving: true, success: false } }, DEEP)
const contractCreateSuccess = (state, { data }) => (
  state.merge(
    {
      newContract: { saving: false, success: true },
      getOne: { result: { contracts: [...state.getOne.result.contracts, data] } },
    },
    DEEP,
  )
)
const contractCreateError = (state, { error }) => (
  state.merge(
    {
      newContract: { saving: false, success: false },
    },
    DEEP,
  )
)
const contractUpdateSuccess = (state, { data }) => {
  const contracts = R.clone(state.getOne.result.contracts)
  const index = R.findIndex(R.propEq('id', data.id))(contracts)
  if (index > -1) {
    contracts[index] = data
  }
  return state.merge(
    {
      getOne: { result: { contracts } },
    },
    DEEP,
  )
}

const contractRestoreSuccess = (state, { id }) => {
  const contracts = R.clone(state.getOne.result.contracts)
  const index = R.findIndex(R.propEq('id', id))(contracts)
  if (index > -1) {
    delete contracts[index].deleted_at
  }
  return state.merge(
    {
      getOne: { result: { contracts } },
    },
    DEEP,
  )
}

const contractRemoveSuccess = (state, { data }) => {
  const contracts = R.clone(state.getOne.result.contracts)
  const index = R.findIndex(R.propEq('id', data.id))(contracts)
  if (index > -1) {
    contracts[index].deleted_at = moment().format('YYYY-MM-DD')
  }
  return state.merge(
    {
      getOne: { result: { contracts } },
    },
    DEEP,
  )
}

const contractCreateReset = state =>
  state.merge({ newContract: { saving: false, success: false, error: '' } }, DEEP)


const getPaymentTypesRequest = state =>
  state.merge({ paymentsTypes: { fetching: true, error: null } }, DEEP)

const getPaymentTypesSuccess = (state, { result }) => (
  state.merge(
    {
      paymentsTypes: { fetching: false, result },
    },
    DEEP,
  )
)

const getPaymentTypesError = (state, { error }) => (
  state.merge(
    {
      paymentsTypes: { fetching: false, error },
    },
    DEEP,
  )
)

const updateInvoiceDetailsRequest = state =>
  state.merge({ getOne: { fetching: true } }, DEEP)
const updateInvoiceDetailsSuccess = (state, { results }) => (
  state.merge(
    { getOne: { fetching: false, result: { invoice_details: results } } },
    DEEP,
  )
)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.getPaymentTypesRequest]: getPaymentTypesRequest,
  [Types.getPaymentTypesSuccess]: getPaymentTypesSuccess,
  [Types.getPaymentTypesError]: getPaymentTypesError,
  [Types.contractCreateRequest]: contractCreateRequest,
  [Types.contractCreateSuccess]: contractCreateSuccess,
  [Types.contractCreateError]: contractCreateError,
  [Types.contractUpdateSuccess]: contractUpdateSuccess,
  [Types.contractRestoreSuccess]: contractRestoreSuccess,
  [Types.contractRemoveSuccess]: contractRemoveSuccess,
  [Types.contractCreateReset]: contractCreateReset,
  [Types.updateInvoiceDetailsRequest]: updateInvoiceDetailsRequest,
  [Types.updateInvoiceDetailsSuccess]: updateInvoiceDetailsSuccess,
  // [Types.setAvailableProducts]: setAvailableProducts,
  // [Types.setAvailableCenters]: setAvailableCenters,
  // [Types.setParamters]: setParamters,
}, {
  defaultActions: {
    get: true,
    getOne: true,
    create: true,
    update: true,
    remove: true,
    restore: true,
    reset: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/CompaniesRedux.js